import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    headers: { "Content-Type": "application/json" },
});

const TOKEN_KEY = "claimhub_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
};

api.interceptors.request.use((config) => {
    const t = getToken();
    if (t) {
        config.headers.Authorization = `Bearer ${t}`;
    }
    return config;
});

export function formatApiError(err) {
    const d = err?.response?.data?.detail;
    if (d == null) return err?.message || "Something went wrong. Please try again.";
    if (typeof d === "string") return d;
    if (Array.isArray(d))
        return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
    if (typeof d?.msg === "string") return d.msg;
    return String(d);
}
